// This is the bridge to your cloud backend
export const API_URL = "https://expense-tracker-fc13.onrender.com";